import React from 'react'

import Text from '../../../../../components/pdf/Text'
import { FOOTER_CHROME_ID } from '../_helpers/pagination'

/**
 * Rodapé das páginas internas. Confirmado por inspeção pixel-a-pixel do PDF-modelo real
 * ("Modelo PGR 2026 - Banco Bradesco_Varejo"): todas as páginas trazem o texto
 * "Segurança do Trabalho – V0_26" alinhado à esquerda, em preto — o documento atual não
 * tinha rodapé nenhum (nenhum `footer` era passado ao `<Page>` em `PdfDocument.js`).
 *
 * Número de página: o modelo também numera cada página no canto inferior direito. Este
 * documento é gerado via impressão do navegador para PDF (ver ADR-0007), então a única
 * forma de inserir um contador de página dinâmico sem tocar em componentes/infra
 * compartilhados é via CSS Paged Media (`@page { @bottom-right { content: counter(page) } }`),
 * suportado pelo motor de impressão do Chromium. Esse `<style>` fica dentro da própria
 * árvore do documento (`#pdfPage`), então é copiado junto pelo `print-js` ao gerar o PDF
 * — não requer alterar `printPdf.js` (compartilhado com outras marcas). Não foi possível
 * validar visualmente esse contador neste ambiente (sem navegador para imprimir/gerar o
 * PDF real) — ver observação no PR.
 */
const Footer = () => (
  <>
    <style>{`
      @page {
        @bottom-right {
          content: counter(page);
          font-family: Arial, Helvetica, sans-serif;
          font-size: 9px;
          color: #000000;
        }
      }
    `}</style>
    {/* `id={FOOTER_CHROME_ID}` — mesma razão do `HEADER_CHROME_ID` em `Header.js`: mede a
        altura real deste bloco para descontar do espaço útil de cada página impressa. */}
    <div id={FOOTER_CHROME_ID} style={{ display: 'block' }}>
      <Text size="xsmall">Segurança do Trabalho – V0_26</Text>
    </div>
  </>
)

export default Footer
